import {registerStyle, styleRule, Theme, UI} from "../../../../../../stem-core/src/ui/UI";
import {StyleSheet} from "../../../../../../stem-core/src/ui/UI";
import {Perk, Coverage} from "./CoverageDescriptionElements";
import {PlusIcon} from "../../../../../SVGElements";


class PlusIconStyle extends StyleSheet {
    @styleRule
    iconElement = {
        margin: "auto",
        padding: "4px 0px",
    }
}

@registerStyle(PlusIconStyle)
class PlusIconElement extends UI.Element {
    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.iconElement);
    }

    render() {
        return <PlusIcon size={14} color={Theme.props.MERCHANT_SPINNER_COLOR}/>
    }
}

const DESCRIPTION_ITEM_TYPE = {
    PERK: "perk",
    PLUS: "plus",
    COVERAGE: "coverage",
};

const descriptionComponentMap = {
    [DESCRIPTION_ITEM_TYPE.PERK]: Perk,
    [DESCRIPTION_ITEM_TYPE.COVERAGE]: Coverage,
    [DESCRIPTION_ITEM_TYPE.PLUS]: PlusIconElement,
};

class CoverageDescriptionStyle extends StyleSheet {
    @styleRule
    coverageDescription = {
        display: "flex",
        flexDirection: "column",
        marginBottom: "auto",
        ">:not(:last-child)": {
            marginBottom: 8,
        },
    }
}

@registerStyle(CoverageDescriptionStyle)
export class CoverageDescription extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            items: [],
        }
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.coverageDescription);
    }

    render() {
        return (this.options.items || []).map(item => {
            const DescriptionComponentClass = descriptionComponentMap[item.type];
            return <DescriptionComponentClass {...item} />
        })
    }
}
